const PROFILE_LOADING = "PROFILE_LOADING";
const PROFILE_ERROR = "PROFILE_ERROR";
const PROFILE_SUCCESS = "PROFILE_SUCCESS";

export { PROFILE_LOADING, PROFILE_ERROR, PROFILE_SUCCESS };